import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import {
  HeaderBannerRail,
  MegaMenuBar,
  MenuLink,
  MobileNav,
  StoreLogo,
} from '@/features/storefront/layouts/chrome/ChromeParts';
import { menuItems, type HeaderProps } from '@/features/storefront/layouts/chrome/types';
import { cn } from '@/lib/cn';

/** Today's storefront header: logo and nav on one row, account and cart right. */
export const Header: FC<HeaderProps> = ({ storeName, logoUrl, header, menu, endSlot, preview }) => {
  const items = menuItems(menu);
  return (
    <header
      className={cn('border-b', header.sticky && !preview && 'sticky top-0 z-40')}
      style={{
        borderColor: 'var(--storefront-surface)',
        backgroundColor: 'var(--storefront-background)',
      }}
    >
      <HeaderBannerRail header={header} preview={preview} />
      <StorefrontContainer className="flex min-h-16 items-center justify-between gap-6 py-2">
        <div className="flex min-w-0 items-center gap-3 sm:gap-6">
          <MobileNav menu={menu} hiddenFrom="sm:hidden" preview={preview} />
          <StoreLogo
            storeName={storeName}
            logoUrl={logoUrl}
            logoWidthPx={header.logo_width_px}
            showStoreName={header.show_store_name}
            preview={preview}
          />
          {items.length > 0 ? (
            <nav aria-label={menu?.name} className="hidden items-center gap-5 sm:flex">
              {items.map((item) => (
                <MenuLink
                  key={`${item.label}:${item.url}`}
                  item={item}
                  preview={preview}
                  className="text-sm font-medium hover:opacity-70"
                />
              ))}
            </nav>
          ) : null}
        </div>
        <div className="flex shrink-0 items-center gap-5">{endSlot}</div>
      </StorefrontContainer>
      <MegaMenuBar header={header} preview={preview} />
    </header>
  );
};
